import {z} from 'zod'

export const KraviaReminderEnum = z.enum([
    'PAYMENT_REMINDER',
    'DEBT_COLLECTION_NOTICE',
    'DO_NOT_SEND'])

export type KraviaReminder = z.infer<typeof KraviaReminderEnum>

export const reminderOptions = [
    {name: 'Purring', value: KraviaReminderEnum.enum.PAYMENT_REMINDER},
    {name: 'Inkassovarsel', value: KraviaReminderEnum.enum.DEBT_COLLECTION_NOTICE},
    {name: 'Skal ikke sendes', value: KraviaReminderEnum.enum.DO_NOT_SEND}
]

export const SubAccountDebtCollectionSettingsSchema = z.object({
    subAccountUuid: z.string().optional(),
    customerSettingsEnabled: z.boolean(),
    reminderType: KraviaReminderEnum,
    intervalDays: z.number()
})

export const customerDebtCollectionValidatorPreprocessor = (obj: { customerSettingsEnabled: boolean }) => {
    if (!obj.customerSettingsEnabled) {
        return null
    }
}

export type SubAccountDebtCollectionSettings = {
    subAccountUuid: string,
    customerSettingsEnabled: boolean,
    reminderType: KraviaReminder,
    intervalDays: number
}